const authority = () => import('@/views/main/authority/authority.vue')
export default {
  path: '/main/authority',
  name: 'authority',
  component: authority,
  children: []
}
